/* Load capacity calculator v1 (2026-07-16 10x build).
   Required per-caster capacity = (total load / caster count) x safety factor.
   Routes the result to the matching duty-tier collection, QuickShip, and a
   pre-filled RFQ. Duty bands: light < 500 lb, medium 500-1500 lb, heavy 1500+. */
if (!customElements.get('load-calculator')) {
	class LoadCalculator extends HTMLElement {
		constructor() {
			super();
			this.form = this.querySelector('form');
			this.result = this.querySelector('[data-result]');
			this.resultNumber = this.querySelector('[data-result-number]');
			this.resultMath = this.querySelector('[data-result-math]');
			this.shopLink = this.querySelector('[data-shop-link]');
			this.quickshipLink = this.querySelector('[data-quickship-link]');
			this.rfqLink = this.querySelector('[data-rfq-link]');

			this.form.addEventListener('submit', (event) => {
				event.preventDefault();
				this.calculate();
			});
		}

		calculate() {
			const weight = Number(this.form.elements.weight.value);
			const casters = Number(this.form.elements.casters.value);
			const factor = Number(this.form.elements.application.value);
			const applicationOption = this.form.elements.application.selectedOptions[0];
			const applicationLabel = applicationOption ? applicationOption.dataset.label : '';

			if (!weight || weight <= 0 || !casters || !factor) {
				return;
			}

			const perCaster = weight / casters;
			const required = Math.ceil((perCaster * factor) / 5) * 5;

			this.resultNumber.textContent = required.toLocaleString('en-US') + ' lbs';
			this.resultMath.textContent =
				weight.toLocaleString('en-US') + ' lbs total ÷ ' + casters + ' casters = ' +
				Math.ceil(perCaster).toLocaleString('en-US') + ' lbs each × ' + factor +
				' safety factor (' + applicationLabel + ') = ' + required.toLocaleString('en-US') + ' lbs minimum rating per caster';

			const tierUrl = this.tierUrl(required);
			if (tierUrl) {
				this.shopLink.href = tierUrl;
				this.shopLink.hidden = false;
			} else {
				this.shopLink.hidden = true;
			}

			const quickshipUrl = this.dataset.quickshipUrl;
			if (quickshipUrl) {
				this.quickshipLink.href = quickshipUrl;
				this.quickshipLink.hidden = false;
			} else {
				this.quickshipLink.hidden = true;
			}

			const rfqUrl = this.dataset.rfqUrl;
			if (rfqUrl) {
				const params = new URLSearchParams({
					product: 'Load calculator result: ' + required + ' lbs minimum per caster, ' + casters +
						' casters, ' + weight + ' lbs total, ' + applicationLabel
				});
				this.rfqLink.href = rfqUrl + '?' + params.toString();
				this.rfqLink.hidden = false;
			} else {
				this.rfqLink.hidden = true;
			}

			this.result.hidden = false;
			this.result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
		}

		tierUrl(required) {
			if (required < 500) {
				return this.dataset.lightUrl || this.dataset.mediumUrl;
			}
			if (required <= 1500) {
				return this.dataset.mediumUrl;
			}
			return this.dataset.heavyUrl;
		}
	}

	customElements.define('load-calculator', LoadCalculator);
}
